import { render } from "./FeatureGate.vue?vue&type=template&id=393dda78"
import script from "./FeatureGate.vue?vue&type=script&lang=js"
export * from "./FeatureGate.vue?vue&type=script&lang=js"

import "./FeatureGate.vue?vue&type=style&index=0&id=393dda78&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon,QBtn});
